import { UIState } from "./ui-state";
import { UIAction, UIActionTypeEnum } from "./ui-action";


const initialState: UIState = {
    progress: false,
    snackBar: {
        show: false,
        message: null,
        messageType: null
    },
    codatState: {
        companyName: null,
        platformName: null,
        statusCode: null,
        errorMessage: null,
        companyId: null,
        integration: null,
        step: null
    },
    currentStepperIndex: 0,
    checkIntegration: false,
    documentUploadBack: false,
    disableButton: true
}
export const UIReducer = (
    state: UIState = initialState,
    action: UIAction
): UIState => {
    switch (action.type) {
        // case UIActionTypeEnum.SET_PROGRESS:{
        //     return {
        //         ...state,
        //         progress: action.progress
        //     };
        // }
        case UIActionTypeEnum.SET_SNACK_BAR: {
            return {
                ...state,
                snackBar: action.snackBar
            };
        }
        case UIActionTypeEnum.INCREASE_CURRENT_STEP_INDEX: {
            return {
                ...state,
                currentStepperIndex: state.currentStepperIndex + 1
            };
        }
        case UIActionTypeEnum.DECREASE_CURRENT_STEP_INDEX: {
            return {
                ...state,
                currentStepperIndex: state.currentStepperIndex - 1
            };
        }
        case UIActionTypeEnum.SET_CURRENT_STEP_INDEX: {
            return {
                ...state,
                currentStepperIndex: action.step
            };
        }
        case UIActionTypeEnum.SET_CHECK_INTEGRATION: {
            return {
                ...state,
                checkIntegration: state.checkIntegration
            };
        }
        case UIActionTypeEnum.SET_DOCUMENT_UPLOAD_BACK: {
            return {
                ...state,
                documentUploadBack: action.documentUploadBack
            };
        }
        case UIActionTypeEnum.SET_DISABLE_BUTTON_CHECK: {
            return {
                ...state,
                disableButton: action.disableButton
            };
        }
        case UIActionTypeEnum.SET_CODAT_CONNECTION: {
            return {
                ...state,
                codatState: action.codatState
            }
        }
        default: {
            return {
                ...state
            };
        }
    }
}
export default UIReducer